import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Restaurant, CustomerDeliveryAddress } from '@/models';
import { isApiResourceLink } from '@/helpers/api';

@Component({
  name: 'CmgFindAChipotleButton',
})
export default class CmgFindAChipotleButton extends Vue {
  // Could be a pickup or delivery address.
  @Prop({ type: Object })
  selectedPickupAddress?: Restaurant;

  @Prop({ type: Object })
  selectedDeliveryAddress?: CustomerDeliveryAddress;

  @Prop({ type: String })
  parentFlagClass?: string;

  @Prop({ type: String })
  public focusChipotle?: string;

  get imageUrl(): string {
    if (this.isRestaurantAddressDefined) {
      return this.$appStore.state.cms.images.icons.pepperSmall.default;
    } else if (this.isDeliveryAddressDefined) {
      return this.$appStore.state.cms.images.icons.car.default;
    }

    return this.$appStore.state.cms.images.logos.pepperWhite.default;
  }

  get isRestaurantAddressDefined(): boolean {
    return !!this.selectedRestaurantAddressLine;
  }

  get isDeliveryAddressDefined(): boolean {
    return !!this.selectedDeliveryAddressLine;
  }

  get selectedRestaurantAddressLine(): string {
    const restaurant = this.selectedPickupAddress;
    if (!restaurant || !restaurant.address) {
      return '';
    }

    const address = restaurant.address;
    if (isApiResourceLink(address)) {
      return '';
    }
    return address.addressLine1 || '';
  }

  get selectedDeliveryAddressLine(): string {
    const deliveryAddress = this.$appStore.state.order.selectedDeliveryAddress;
    if (!deliveryAddress) {
      return '';
    }
    return deliveryAddress.name ? deliveryAddress.name.toUpperCase() : null || deliveryAddress.streetAddress1 || '';
  }
}
